import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import { validate } from '@adornis/validation/decorators.js';
import { nonOptional } from '@adornis/validation/functions/nonOptional.js';
import { DateTime } from 'luxon';

@Entity()
export class BaseLog extends MongoEntity {
  static override _class = 'BaseLog';
  static override _collectionName = 'base-logs';

  @validate(nonOptional())
  @Field(type => String)
  userID!: string;

  @validate(nonOptional())
  @Field(type => DateTime, { default: v => v ?? DateTime.now() })
  createdAt!: DateTime;
}
